// ============================================================================
// Providers
// ============================================================================

// Browser Provider - The recommended way to use Insforge in Next.js
// Use this directly in a client component for proper SDK client sharing
export {
  InsforgeBrowserProvider,
  ClientInsforgeProvider, // Deprecated alias
  type InsforgeBrowserProviderProps,
  type InitialAuthState,
} from './client/provider';

// Server-only exports (uses conditional exports via #components)
// In Server Components: exports auth, getAuthFromCookies, InsforgeServerProvider
// In Client Components: not available (will error if imported, which is correct)
export {
  auth,
  type InsforgeAuth,
  getAuthFromCookies,
  InsforgeServerProvider,
  type InsforgeServerProviderProps,
  type InsforgeProviderServerProps,
} from '#components';

// Hooks (from client)
export { useInsforge } from './client/provider';

/**
 * These need to be explicitly listed. Do not use an * here.
 * If you do, app router will break.
 *
 * Pattern learned from @clerk/nextjs
 */

// Main UI Components
export {
  SignIn,
  SignUp,
  ForgotPassword,
  ResetPassword,
  VerifyEmail,
  UserButton,
  Protect,
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton,
} from './client/components';

// Form Components
export {
  SignInForm,
  SignUpForm,
  ForgotPasswordForm,
  ResetPasswordForm,
  VerifyEmailStatus,
} from './client/components';

// Atom Components
export {
  AuthBranding,
  AuthContainer,
  AuthHeader,
  AuthErrorBanner,
  AuthFormField,
  AuthPasswordField,
  AuthPasswordStrengthIndicator,
  AuthSubmitButton,
  AuthLink,
  AuthDivider,
  AuthOAuthButton,
  AuthOAuthProviders,
  AuthVerificationCodeInput,
  AuthEmailVerificationStep,
  AuthResetPasswordVerificationStep,
} from './client/components';

// Component Types
export type {
  SignInProps,
  SignUpProps,
  ForgotPasswordProps,
  ResetPasswordProps,
  VerifyEmailProps,
  UserButtonProps,
  ProtectProps,
  ConditionalProps,
  SignInFormProps,
  SignUpFormProps,
  ForgotPasswordFormProps,
  ResetPasswordFormProps,
  VerifyEmailStatusProps,
  AuthContainerProps,
  AuthHeaderProps,
  AuthErrorBannerProps,
  AuthFormFieldProps,
  AuthPasswordFieldProps,
  AuthPasswordStrengthIndicatorProps,
  AuthSubmitButtonProps,
  AuthLinkProps,
  AuthDividerProps,
  AuthOAuthButtonProps,
  AuthOAuthProvidersProps,
  AuthVerificationCodeInputProps,
} from './client/components';

// Hooks
export { useAuth, useUser, usePublicAuthConfig } from './client/hooks';
